import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'

import DashboardPanel from '@/components/dashboard/DashboardPanel'
import PanelSwitch from '@/components/dashboard/PanelSwitch'
import { selectVisibleDashboardPanels } from '@/selector'

import '@/components/dashboard/Dashboard.less'

const Dashboard = () => {
    
    const visibleDashboardPanels = useSelector(selectVisibleDashboardPanels)
    const dashboardPanels = visibleDashboardPanels.map((value) => {
        return (
            <DashboardPanel key={`panel-${value}`} type={value} />
        )
    })

    return (
        <Fragment>
            <PanelSwitch />
            <div className="dashboard">
                {dashboardPanels}
            </div>
        </Fragment>
    )
}

export default Dashboard